import { memo, useState, useEffect, useCallback, useImperativeHandle, forwardRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { Container, Row, Col } from 'react-bootstrap';
import { BzChip, BzHeading, BzCard, BzDatePicker, BzInputText, BzLoader } from '../../components';
import { useLocation } from 'react-router';
import { DASHBOARD_EXPLORE_CATEGORY, EXCHANGE_NAME_API, LOCATIONS } from '../../utils/global_variables';
import { EVENT_REF } from '../../utils/global_functions';

import { handleModal } from '../../redux/actions/modals';
import EventDetailsModal from './EventDetailsModal';
import ZeroStates from '../ZeroStates';
import { clearEventsState, event, updateActiveEvent, updateEventDate, updateEventsSearchText } from '../../redux/actions/events';

const exhcangeType = EXCHANGE_NAME_API.NSE_EQ_API;

const Events = forwardRef(({ ...props }, ref) => {

    const dispatch = useDispatch();
    const location = useLocation();

    const events = useSelector(state => state?.events?.events);
    const activeEvent = useSelector(state => state?.events?.activeEvent);
    const eventsDate = useSelector(state => state?.events?.selectedDate);
    const searchText = useSelector(state => state?.events?.eventsSearchText);
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const isEventFailed = useSelector(state => state?.events?.isEventFailed);
    const isEventPending = useSelector(state => state?.events?.isEventPending);

    const [filterEvents, setFilterEvents] = useState([]);
    const [detailedEvent, setDetailedEvent] = useState();
    const [objEvent, setObjEvent] = useState({});
    const [objSearchedEvents, setObjSearchedEvents] = useState({});
    const [isPickerOpen, setIsPickerOpen] = useState(false);


    const updatedDate = useMemo(() => {
        if (eventsDate?.length) {
            const date = dayjs(eventsDate, 'D-MMM-YYYY');
            return date;
        } else { }
    }, [eventsDate]);



    const holdingEvents = useMemo(() => {
        if (holdingsScrips?.length) {
            const eventData = objEvent?.data?.filter(event =>
                holdingsScrips?.find(holding => holding?.sSymbol === event?.title)
            ) || [];
            if (searchText?.length) {
                const searchedEventList = eventData?.filter((each) => each.title.toLowerCase().includes(searchText?.toLowerCase()));
                return { event: objEvent?.event, data: searchedEventList };
            }
            else {
                return { event: objEvent?.event, data: eventData };
            }
        }
        else {
            return objEvent;
        }
    }, [holdingsScrips, objEvent, searchText]);

    const getSelectedDateWiseEvents = useCallback((selectedDate) => {
        if (location.pathname === LOCATIONS.PORTFOLIO) {
            const selectedDateEvents = events?.map(function (event) {
                const filteredData = event?.data?.filter(function (data) {
                    const { eventDate, title } = data;
                    return eventDate === selectedDate && holdingsScrips?.find(holding => holding?.sSymbol === title);
                });
                if (filteredData.length > 0) {
                    return {
                        event: event.event,
                        data: [...filteredData]
                    };
                } else {
                    return null;
                }
            }).filter(event => event !== null);
            return selectedDateEvents;
        }
        else {
            const selectedDateEvents = events?.map(function (event) {
                const filteredData = event?.data?.filter(function (data) {
                    const { eventDate } = data;
                    return eventDate === selectedDate;
                });
                if (filteredData.length > 0) {
                    return {
                        event: event.event,
                        data: [...filteredData]
                    };
                } else {
                    return null;
                }
            }).filter(event => event !== null);
            return selectedDateEvents;

        }
    }, [events, holdingsScrips, location.pathname, eventsDate]);

    useEffect(() => {
        if (eventsDate) {
            setFilterEvents(getSelectedDateWiseEvents(eventsDate));
        } else { }
    }, [eventsDate, getSelectedDateWiseEvents]);

    const onDateChange = useCallback((date, dateString) => {
        if (dateString) {
            const formatedPrevousDate = dayjs(eventsDate, "DD-MMM-YYYY");
            const formatedCurrentDate = dayjs(dateString, "DD-MMM-YYYY");
            if ((!formatedPrevousDate.isSame(formatedCurrentDate, 'month')) || (!formatedPrevousDate.isSame(formatedCurrentDate, 'year'))) {
                const startDate = formatedCurrentDate.startOf('month').format('D-MMM-YYYY');
                const endDate = formatedCurrentDate.endOf('month').format('D-MMM-YYYY');
                dispatch(clearEventsState());
                dispatch(event(startDate, endDate, exhcangeType, 1, dateString, location.pathname));
            } else { }
            dispatch(updateEventsSearchText(""));
            dispatch(updateActiveEvent('ALL'));
            setIsPickerOpen(false);
            dispatch(updateEventDate(dateString));
            setFilterEvents(getSelectedDateWiseEvents(dateString));
        } else { }
    }, [eventsDate]);

    const getActiveEventsList = (filterEvents, activeEvent) => {
        if (filterEvents?.length > 0 && activeEvent) {
            let [filteredEventlist] = filterEvents?.filter(elem => elem.event == activeEvent);
            setObjEvent(filteredEventlist);
        } else if (filterEvents?.length <= 0) {
            setObjEvent({});
        }
    };

    useEffect(() => {
        if (filterEvents?.length > 0 && activeEvent?.length > 0) {
            getActiveEventsList(filterEvents, activeEvent);
        } else { }
    }, [filterEvents, activeEvent, updatedDate]);

    useEffect(() => {
        if (searchText?.length > 0) {
            const searchedEventList = objEvent?.data?.filter((each) => each.title.toLowerCase().includes(searchText?.toLowerCase()));
            setObjSearchedEvents({ ...objEvent, data: searchedEventList });
        } else {
            setObjSearchedEvents({ ...objEvent });
        }
    }, [searchText, objEvent, updatedDate]);

    useEffect(() => {
        if (filterEvents?.length <= 0) {
            setObjEvent({});
        }
    }, [filterEvents]);

    const getEventsDateForCalender = (date) => {
        // Hari K:02-01-2024:BT-117132:Holdings-Events calendar-issues fixed-start
        if (location.pathname === LOCATIONS.PORTFOLIO) {
            const eventsDates = events[0]?.data?.filter(event => holdingsScrips?.map(holding => holding?.sSymbol)?.includes(event?.title))?.map(obj => obj?.eventDate);
            const dotNotes = [];
            eventsDates?.map((eventDate) => {
                if (eventDate?.includes(date?.format('DD-MMM-YYYY'))) {
                    dotNotes?.push({});
                }
                return dotNotes;
            }, []);
            return dotNotes;
            // Hari K:02-01-2024:BT-117132:Holdings-Events calendar-issues fixed-end
        } else {
            const dotNotes = events?.reduce((array, emp) => {
                const eventsDates = emp?.data?.map((each) => each.eventDate);
                if (eventsDates?.includes(date?.format('DD-MMM-YYYY'))) {
                    array?.push({});
                }
                return array;
            }, []);
            return dotNotes;
        }
    };

    const dateCellRender = (date) => {
        const dotNotes = getEventsDateForCalender(date);
        if (dotNotes?.length > 0) {
            return (
                <div style={{ position: 'relative' }}>
                    <span>{date?.date()}</span>
                    <div style={{ position: 'absolute', left: '0', right: '0', textAlign: 'center' }}>
                        <div className='dotStyle'></div>
                    </div>
                </div>
            );
        } else {
            return (<span>{date?.date()}</span>);
        }
    };

    const handleExpandCollapse = useCallback(() => {
        if (props.isExpandCollapse) {
            props.setIsExpandCollapse(false);
            props.setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.MAIN);
        }
        else {
            props.setIsExpandCollapse(true);
            props.setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.EVENTS);
        }
    }, []);


    const handleEventDetailsModal = (event) => {
        setDetailedEvent({ ...event, ltp: "0", changeInPersent: '0', changeInPrice: '0' });
        dispatch(handleModal([{ "EVENTS_DETAILS": true }]));
    };


    // Hari K : 21-08-2023 BT-107424 seach functionality 
    const onSearchChange = (value) => {
        dispatch(updateEventsSearchText(value));
    };

    const handleEventTabs = (eventTab) => {
        dispatch(updateEventsSearchText(""));
        dispatch(updateActiveEvent(eventTab));
    };

    const handlePanelChange = useCallback((value) => {
        const startDate = value.startOf('month').format('D-MMM-YYYY');
        const endDate = value.endOf('month').format('D-MMM-YYYY');
        const currentDate = value.format('DD-MMM-YYYY');
        setIsPickerOpen(true);
        dispatch(event(startDate, endDate, exhcangeType, 1, currentDate, location.pathname));
        dispatch(updateEventDate(currentDate));
        dispatch(updateEventsSearchText(""));
        dispatch(updateActiveEvent('ALL'));

    }, []);



    useImperativeHandle(ref, () => ({
        getEventsDateForCalender,
        getSelectedDateWiseEvents,
        setFilterEvents,
        getActiveEventsList,
        setObjEvent,
        handleEventTabs,
        handlePanelChange,
        onDateChange,
    }));


    useEffect(() => {
        if (events?.length <= 0) {
            if (eventsDate) {
                const date = dayjs(eventsDate);
                const eventStartDate = date?.startOf('month').format('D-MMM-YYYY');
                const eventEndDate = date?.endOf('month').format('D-MMM-YYYY');
                dispatch(event(eventStartDate, eventEndDate, exhcangeType, 1, eventsDate, location.pathname));
            }
        } else { }
    }, [eventsDate]);


    return (
        <>
            {location.pathname === LOCATIONS.PORTFOLIO ?
                <Container fluid className='p-0'>
                    <div className='py-2'>
                        <Row className='g-0 mb-2'>
                            <Col className='d-flex align-items-center'>
                                <div className='datepicker-wrap p-0'>
                                    <BzDatePicker className='form-datepicker-secondary form-control font-medium py-1 px-2' disabled={isEventPending} open={isPickerOpen} setIsPickerOpen={setIsPickerOpen} defaultValue={updatedDate} key={updatedDate} mode={'date'} dateFormat={"DD-MMM-YYYY"} picker={"date"} handlePanelChange={handlePanelChange} onDateChange={onDateChange} selectedDate={updatedDate} dateCellRender={dateCellRender} />
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-2'>
                            <Col md={8} className='d-flex justify-content-start align-items-center'>
                                <div className='submenu-wrapper horizontal-scroll-wrap pb-2'>
                                    {filterEvents.map((each, i) => (
                                        <BzChip key={i} className={`submenuItem ${each?.event === activeEvent ? 'active' : ''}`} onClick={() => handleEventTabs(each?.event)}>{each?.event}</BzChip>
                                    ))}
                                </div>
                            </Col>
                            <Col md={4} className='d-flex justify-content-end align-items-center pe-1'>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText value={searchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                </div>
                            </Col>
                        </Row>
                        <div className='portfolio-eventstabs-scroll'>
                            {holdingEvents?.data?.length ?
                                holdingEvents?.data?.map((each, i) => (
                                    <BzCard key={i} className='py-2 bdr-btm' onClick={() => handleEventDetailsModal(each)}>
                                        <Row className='g-0 mb-2'>
                                            <Col md={9} className='d-flex justify-content-start align-self-center'>
                                                <div className='font-medium font-size4 color-text text-uppercase'>
                                                    {each.title}
                                                </div>
                                            </Col>
                                            <Col md={3} className='d-flex justify-content-end align-self-center'>
                                                <div className='icon-28 icon-next icon-dark me-1'></div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col className='chips-wrap'>
                                                <BzChip className='chips primary-chip font-medium font-size3'>{each?.eventType}</BzChip>
                                                &nbsp;
                                                {/* <BzChip>{Object.keys(each).includes('Memo') ? each.Memo : each.description}</BzChip> */}
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col>
                                                <div className='font-regular font-size1 color-subtext'>{each.eventDate.split("-")[0]} {each.eventDate.split("-")[1]} {each.eventDate.split("-")[2]}</div>
                                            </Col>
                                        </Row>
                                    </BzCard>
                                ))
                                : holdingEvents?.data?.length <= 0 && searchText?.length > 0 ?
                                    <div className='zero-state-alerts zero-state-alerts-lg'>
                                        <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                    </div>
                                    : events?.length > 0 && isEventPending !== true && JSON.stringify(objSearchedEvents) === JSON.stringify({}) || isEventFailed ?
                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                            <ZeroStates subText="We could find no new Events..." isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                        </div>
                                        : isEventPending ?
                                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                                <BzLoader spinner={isEventPending} spinnerContent={"Fetching Details"} />
                                            </div>
                                            : null}
                        </div>
                    </div>
                    <EventDetailsModal detailedEvent={detailedEvent} />
                </Container>
                : (location.pathname === LOCATIONS.WATCHLIST ?
                    <div className='px-3'>
                        <div className='transparent-card-wrap'>
                            {
                                objSearchedEvents && objSearchedEvents?.data?.length > 0 ? objSearchedEvents?.data?.map((each, i) => (
                                    <BzCard key={i} className='transparent-card cursor-pointer bdr-card-btm' onClick={() => handleEventDetailsModal(each)}>
                                        <Row className='g-0 mb-2'>
                                            <Col md={9} className='d-flex justify-content-start align-self-center'>
                                                <div className='font-medium font-size3 color-text'>
                                                    {each.title}
                                                </div>
                                            </Col>
                                            <Col md={3} className='d-flex justify-content-end align-self-center'>
                                                <div className='icon-24 icon-next icon-dark ms-3'></div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col className='chips-wrap'>
                                                <BzChip className='chips primary-chip align-self-center'>{each.eventType}</BzChip>
                                            </Col>
                                        </Row>
                                        {/* <Row className='g-0 mb-2'>
                                        <Col className='justify-content-start align-self-center'>
                                            <div className='font-regular font-size3 color-subtext'>{Object.keys(each).includes('Memo') ? each.Memo : each.description}</div>
                                        </Col>
                                    </Row> */}
                                        <Row className='g-0'>
                                            <Col className='justify-content-start align-self-center'>
                                                <div className='font-regular font-size1 color-subtext'>{each.eventDate}</div>
                                            </Col>
                                        </Row>
                                    </BzCard>
                                ))
                                    : objSearchedEvents?.data?.length <= 0 && searchText.length > 0 ?
                                        <div className='zero-state-alerts zero-state-alerts-xl'>
                                            <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                        </div>
                                        :
                                        (events?.length > 0 && isEventPending !== true && JSON.stringify(objSearchedEvents) === JSON.stringify({})) || isEventFailed ?
                                            < div className='zero-state-alerts zero-state-alerts-xl'>
                                                <ZeroStates subText="We could find no new Events..." isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                            </div>
                                            : isEventPending ?
                                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                                    <BzLoader spinner={isEventPending} spinnerContent={"Fetching Details"} />
                                                </div>
                                                : null}
                        </div>
                    </div>
                    : (location.pathname === LOCATIONS.DASHBOARD ?
                        <Container fluid className={props.isExpandCollapse ? 'p-0 px-3 dashboard-content-wrapper events-expanded' : 'g-0'} ref={EVENT_REF}>
                            <div className='dashboard-events'>
                                <Row className={`${props.isExpandCollapse ? '' : 'px-3'} g-0 dashboard-cards-header align-items-center`}>
                                    <Col md={6} className='d-flex justify-content-start'>
                                        <div className='heading-border'>
                                            <div className='font-medium font-size8 color-text text-uppercase line-height-1 ms-3'>EVENTS</div>
                                        </div>
                                    </Col>
                                    <Col md={6} className='d-flex justify-content-end align-items-center'>
                                        <div className='datepicker-wrap p-0'>
                                            <BzDatePicker className='form-datepicker-secondary form-control font-medium py-1 px-2'
                                                handlePanelChange={handlePanelChange} open={isPickerOpen} setIsPickerOpen={setIsPickerOpen} defaultValue={updatedDate} key={updatedDate} mode={'date'} dateFormat={"DD-MMM-YYYY"} picker={"date"} onDateChange={onDateChange} selectedDate={updatedDate} disabled={isEventPending} dateCellRender={dateCellRender} />
                                        </div>
                                        <div className='background-icon ms-3' onClick={handleExpandCollapse}>
                                            <div data-testid="test-expandCollapseIcon" className={`icon-16 icon-dark ${props.isExpandCollapse ? 'icon-collapse' : 'icon-expand'}`}></div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='dashboard-cards-container p-3'>
                                    {filterEvents?.length ?
                                        <Row className='g-0 mb-3'>
                                            <Col >
                                                <div data-testid="test-eventsChips" className='submenu-wrapper horizontal-scroll-wrap py-1'>
                                                    {filterEvents.map((eachEvent) => (
                                                        <BzChip className={`submenuItem ${eachEvent.event === activeEvent ? 'active' : ''}`} key={eachEvent.event} value={eachEvent.event} onClick={() => handleEventTabs(eachEvent.event)}>{eachEvent.event}</BzChip>
                                                    ))}
                                                </div>
                                            </Col>
                                        </Row> : null}
                                    <Row className='g-0 mb-2'>
                                        <Col md={props.isExpandCollapse ? 4 : 6}>
                                            <div className='position-relative'>
                                                <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                                <BzInputText value={searchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30  font-regular'></BzInputText>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-2'>
                                        <div className='events-card-wrapper position-relative'>
                                            <div className='transparent-card-wrap'>
                                                {objSearchedEvents && objSearchedEvents?.data?.length > 0 == true ?
                                                    <>
                                                        {
                                                            objSearchedEvents?.data?.map((each, i) => (
                                                                <BzCard data-testid="test-eventCard" key={i} className='transparent-card cursor-pointer bdr-card-btm' onClick={() => handleEventDetailsModal(each)}>
                                                                    <Row className='g-0 mb-2'>
                                                                        <Col md={9} className='d-flex justify-content-start align-self-center'>
                                                                            <BzHeading className='font-medium font-size4 color-text text-uppercase'>
                                                                                {each.title}
                                                                            </BzHeading>
                                                                        </Col>
                                                                        <Col md={3} className='d-flex justify-content-end align-self-center'>
                                                                            <div className='icon-24 icon-next icon-dark'></div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0 mb-2'>
                                                                        <Col className='chips-wrap'>
                                                                            <BzChip className='chips primary-chip font-medium font-size3'>{each.eventType}</BzChip>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0 mb-2'>
                                                                        <Col>
                                                                            <div className='font-regular font-size1 color-subtext'>{each.eventDate.split("-")[0]} {each.eventDate.split("-")[1]} {each.eventDate.split("-")[2]}</div>
                                                                        </Col>
                                                                    </Row>
                                                                </BzCard>
                                                            ))
                                                        }

                                                    </>
                                                    : objSearchedEvents?.data?.length <= 0 && searchText.length > 0 ?
                                                        <div className='zero-state-alerts zero-state-alerts-lg'>
                                                            <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                        </div>
                                                        : (events?.length > 0 && isEventPending !== true && JSON.stringify(objSearchedEvents) === JSON.stringify({})) || isEventFailed ?
                                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                                <ZeroStates subText="We could find no new Events..." isButtonShowing={false} icon='icon-64 icon-nodata mb-3 mrgauto' />
                                                            </div>
                                                            : isEventPending ?
                                                                <div className='zero-state-alerts zero-state-alerts-lg'>
                                                                    <BzLoader spinner={isEventPending} spinnerContent={"Fetching Details"} />
                                                                </div>
                                                                : null}
                                            </div>
                                        </div>
                                    </Row>
                                </div>
                            </div>
                        </Container>
                        : null
                    )
                )
            }
            {/* Vinit R 15-03-2024 - Close watchlist sidetray on click of buy/sell or add watchlist buttons from news component -- Start */}
            <EventDetailsModal detailedEvent={detailedEvent} setActiveButtonToggleIndex={props.setActiveButtonToggleIndex} />
            {/* Vinit R 15-03-2024 - Close watchlist sidetray on click of buy/sell or add watchlist buttons from news component -- End */}
        </>

    );
});
export default memo(Events);